import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  neonLink: {
    display: 'block'
  },
  neonLogo: {
    display: 'block'
  }
})

export default useStyles
